const POST_SIGN_IN_FALLBACK = '/(tabs)/events' as const;

export function resolvePostSignInHref(next?: string | string[]) {
  const route = typeof next === 'string' ? next.trim() : '';
  // next is user-controllable query state; only known internal return paths survive sign-in.
  return isAllowedPostSignInRoute(route) ? (route as never) : POST_SIGN_IN_FALLBACK;
}

function isAllowedPostSignInRoute(route: string) {
  if (
    route === '/workspaces' ||
    route === '/onboarding/profile-setup' ||
    route === '/(business)/activity' ||
    /^\/\(tabs\)\/(?:events|map|activity|profile)$/.test(route)
  ) {
    return true;
  }

  return (
    /^\/events?\/[^/?#]+$/.test(route) ||
    /^\/venues\/[^/?#]+(?:\/approved|\/claim|\/edit)?$/.test(route) ||
    /^\/profiles\/[^/?#]+$/.test(route) ||
    /^\/invitations\/[^/?#]+$/.test(route) ||
    /^\/workspaces\/[^/?#]+(?:\/(?:team|events|organization))?$/.test(route)
  );
}
